module.exports = __webpack_public_path__ + "static/media/ic_class_album.196c7137.png";